
<template>
  <!-- 入库 -->
  <div class="no-group">
    <!-- 表格 -->
    <div class="group-content">
      <div class="group-title">患者管理_终止流程</div>
        <div class="model-type" >
       <span>确认结束此次跟踪流程吗？</span>
       <span>确认后此记录会归类到患者历史流程中</span>
      </div>
      <div>
        <textarea placeholder="请输入原因......" v-model="cancelReason" cols="30" rows="10"></textarea>
      </div>
      <div style="margin-top:10px">
        <a-button type="primary" @click="sure()" style="margin-right:16px;">确定</a-button>
        <a-button @click="cancel()">取消</a-button>
      </div>
    </div>
      </div>

</template>

<script>
// import PopupContainer from "@/components/common/popupContainer.vue";

export default {
    props:['end'],
  data() {
    return {
      cancelReason:''
    };
  },
  methods: {
    cancel(){
      this.$emit('close')
    },
    sure(){
      if(this.cancelReason==null||this.cancelReason==''){
        this.$message.error('请输入终止流程原因')
      }else{
        this.end.cancelReason = this.cancelReason;
        this.$post('patientitem/patientItem/patientItemConfirmationBatch?operateType=flow-canceled', [this.end],true).then((r) => {
          if(r.status == 200){
            this.$message.success(r.data.message)
            this.$emit('close')
            this.$emit('update')
          }
          this.loading = false;
        }).catch((e) => {
          this.$message.error(e);
        })
      }
    }
  }
};
</script>
<stylelang="scss" scoped>
.no-group .popup-container .header {
  height: 40px;
}
.model-content{
  width: 240px;
  margin: 82px auto 0;
  text-align: left;
  .title{
    font-size:26px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
  }

  .btn-group{
    margin-top: 25px;
    button{
       width: 100px;
    }
   button:nth-child(2){
     margin-left: 20px;
   }
  }

}
.group-content {
  height: 500px;
  width: 386px;
    margin: 82px auto 0;
  .group-title {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 52px;
  }
  .model-type{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    margin-top: 52px;
    margin-bottom: 25px;
    span{
      display: block;
    }
    span:nth-child(2){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(164,164,164,1);
    }
  }
  textarea {
    width: 386px;
    height: 202px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(66, 142, 247, 1);
    padding:10px;
  }
}
.table-th {
  color: #a4a4a4;
}
.sure-button {
  width: 680px;
  margin: 50px auto 0;
  padding-bottom: 50px;
  .ant-btn {
    height: 42px;
  }
}
</style>